module.exports = __webpack_public_path__ + "static/media/Barnum–Forer Effect - rostyslav-savchyn-E2zvqyY5zUY-unsplash.f6bc260d.jpg";